import AccountHistory from "./account-history";
import SubscriptionBilling from "./subscription-billing";
import styles from "./index.module.scss";
import ExtendTrialModal from "./extend-trial-modal";
import { useEntity } from "../../hooks/use-entity.hook";
import { Flaggers } from "../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../common/store/flaggers/flaggers.methods";
import { ModalData } from "../../common/types/app.types";
import ConvertSubscriptionModal from "./convert-subscriptio-modal";
import InfoBanner from "../Common/info-banner";

interface SubscriptionDetailsProps {
  isDistributorView?: boolean;
  isDistributorMspAccountInfo?: boolean;
  infoMessage?: string;
}

const SubscriptionDetails = ({isDistributorView = false, isDistributorMspAccountInfo = false, infoMessage}: SubscriptionDetailsProps) => {
  const { entityData: extendTrialModalData, setEntityData: setExtendTrialModalData } = useEntity<ModalData | null>({ entityType: Flaggers.ExtendTrialModalFlagger });
  const { entityData: convertSubscriptionModalData, setEntityData: setConvertSubscriptionModalData } = useEntity<ModalData | null>({ entityType: Flaggers.ConvertSubscriptionModalFlagger });

  const handleOpenExtendTrialModal = () => {
    setExtendTrialModalData({ show: true }, FlaggersMethods.UpdateFlagger)
  }

  const handleCloseExtendTrialModal = () => {
    setExtendTrialModalData(null, FlaggersMethods.UpdateFlagger)
  }

  const handleOpenConvertSubscriptionModal = () => {
    setConvertSubscriptionModalData({ show: true }, FlaggersMethods.UpdateFlagger)
  }

  const handleCloseConvertSubscriptionModal = () => {
    setConvertSubscriptionModalData(null, FlaggersMethods.UpdateFlagger)
  }

  return (
    <div className={styles.page}>
      <AccountHistory onViewDetails={handleOpenExtendTrialModal} isDistributorView={isDistributorView} />
      <div className="d-flex flex-column gap-10">
        <InfoBanner message={infoMessage ?? `This MSP has exceeded their license limit for Plan 1 (max 100 clients).\nPlease contact them to arrange a plan upgrade within 30 days — otherwise, their account will be suspended.`} />
        <SubscriptionBilling onExtendTrial={handleOpenExtendTrialModal} onConvertSubscription={handleOpenConvertSubscriptionModal} isDistributorView={isDistributorView} isDistributorMspAccountInfo={isDistributorMspAccountInfo} />
      </div>
      <ExtendTrialModal
        show={extendTrialModalData?.show || false}
        onClose={handleCloseExtendTrialModal}
        onConfirm={() => {}}
        isSendRequestView={!isDistributorMspAccountInfo}
      />
      <ConvertSubscriptionModal
        show={convertSubscriptionModalData?.show || false}
        onClose={handleCloseConvertSubscriptionModal}
        onConfirm={() => {}}
      />
    </div>
  );
};

export default SubscriptionDetails;
